import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, ListGroupItem } from 'reactstrap';
import { actions } from '../../../../context';
import Split from '../../../Shared/Split';

const AccountToModify = ({ accountId, connectedToPartner, firstName, lastName, email, refresh, partnerId }) => {

    const dispatch = useDispatch();
    const [adding, setAdding] = useState(false);
    
    const toggleAccount = () => {
        setAdding(true);
        let request;
        if (connectedToPartner) {
            request = dispatch(
                actions.accounts.removeAccountFromPartner(partnerId, accountId)
            );
        } else {
            request = dispatch(
                actions.accounts.addAccountToPartner(partnerId, accountId)
            );
        }
        request
            .then((res) => refresh())
            .catch((err) => console.error(err))
            .finally(setAdding(false));
    };

    return (
        <ListGroupItem className="text-dark">
            <Split>
                <div>
                    <div>{firstName}&nbsp;{lastName}</div>
                    <div className="text-14 op-7">{email}</div>
                </div>
                <div>
                    <Button
                        color={
                            connectedToPartner ? 'danger' : 'primary'
                        }
                        disabled={adding}
                        size="sm"
                        onClick={toggleAccount}>
                        {connectedToPartner
                            ? adding
                                ? 'Removing'
                                : 'Remove'
                            : adding
                            ? 'Adding'
                            : 'Add'}
                    </Button>
                </div>
            </Split>
        </ListGroupItem>
    );
};

export default AccountToModify;
